import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import styles from './styles.module.scss'
import { Board } from '../../../components/Board';
import { NavButton } from '../../../components/NavButton';
import {
  verifyRoutePermissions
} from '../../../globalFunctions';
import { useNavigate } from 'react-router-dom';
import { MessageContext } from '../../../providers/MessageProvider';

interface Question {
  id: number;
  desc: string;
  img: string;
  correctOption: number;
}

interface Pilares {
  abstracao: boolean;
  decomposicao: boolean;
  padroes: boolean;
  algoritimos: boolean;
}

export const QuizMaker = () => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [newQuestion, setNewQuestion] = useState({ desc: '', img: '', correctOption: 1 });
  const [editingQuestion, setEditingQuestion] = useState<Question | null>(null);
  const [editingPilar, setEditingPilar] = useState<Pilares>({ abstracao: false, decomposicao: false, padroes: false, algoritimos: false });
  const pilares = ["Abstração", "Decomposição", "Reconhecimento de padrões", "Algoritmos"]
  const abc = ["A", "B", "C", "D"]
  const pilarKeys = ['abstracao', 'decomposicao', 'padroes', 'algoritimos'] as const;
  const { setOpenMessage, setMessage } = useContext(MessageContext);

  const navigate = useNavigate()
  useEffect(() => {
    const user = verifyRoutePermissions(
      ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
      navigate
    );
  }, []);
  const goBackwards = () => {
    navigate('/manager');
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/quiz`);
      setQuestions(response.data);
    } catch (error) {
      console.error('Erro ao buscar questões:', error);
    }
  };

  const addQuestion = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/quiz`, { ...newQuestion, ...editingPilar });
      setNewQuestion({ desc: '', img: '', correctOption: 1 });
      fetchQuestions();
      console.log(response.data)
      setOpenMessage(true)
      setMessage({ content: "Questão adicionada com sucesso", type: "success" })
    } catch (error) {
      setMessage({ content: "Erro ao adicionar questão", type: "success" })
      console.error('Erro ao adicionar questão:', error);
    }
  };

  const editQuestion = async () => {
    if (editingQuestion) {
      try {
        await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/quiz/${editingQuestion.id}`, { ...newQuestion, ...editingQuestion });
        setEditingQuestion(null);
        fetchQuestions();
      } catch (error) {
        console.error('Erro ao editar questão:', error);
      }
    }
  };

  const deleteQuestion = async (id: number) => {
    setOpenMessage(true)
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/quiz/${id}`);
      fetchQuestions();
      setMessage({ content: "Questão adicionada com sucesso", type: "success" })

    } catch (error) {
      console.error('Erro ao excluir questão:', error);
      setMessage({ content: "Erro ao excluir questão", type: "success" })

    }



  };

  return (


    <div className={styles.wrapper}>

      <Board wrapperClass={styles.board}>
        <NavButton
          direction='left'
          style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
          onClick={goBackwards}
        />

        <h1 className={styles.title}>Quiz de lógica computacional</h1>

        <div className={styles.form}>
          <h2>{editingQuestion ? 'Editar Questão' : 'Adicionar Nova Questão'}</h2>
          <textarea
            title='Descrição da questão'
            placeholder="Descrição da questão"
            value={editingQuestion ? editingQuestion.desc : newQuestion.desc}
            onChange={(e) =>
              editingQuestion
                ? setEditingQuestion({ ...editingQuestion, desc: e.target.value })
                : setNewQuestion({ ...newQuestion, desc: e.target.value })
            }
          />
          <h4>Insira a imagem da questão:</h4>
          <input
            type="file"
            accept=".jpg, .jpeg, .png, .webp, .bmp"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                const validTypes = ["image/jpeg", "image/png", "image/webp", "image/bmp"];
                if (!validTypes.includes(file.type)) {
                  alert("Formato de imagem inválido! Apenas JPG, PNG, WEBP e BMP são permitidos.");
                  return;
                }
                const reader = new FileReader();
                reader.onloadend = () => {
                  const base64String = reader.result as string;
                  if (editingQuestion) {
                    setEditingQuestion({ ...editingQuestion, img: base64String });
                  } else {
                    setNewQuestion({ ...newQuestion, img: base64String });
                  }
                };
                reader.readAsDataURL(file);
              }
            }}
          />
          <h4>Alternativa correta:</h4>
          <div className={styles.radioGroup} style={{ display: 'flex', gap: '10px' }}>
            {[1, 2, 3, 4].map((num) => (
              <label key={num} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="radio"
                  name="correctOption"
                  value={num}
                  checked={editingQuestion ? editingQuestion.correctOption === num : newQuestion.correctOption === num}
                  onChange={(e) =>
                    editingQuestion
                      ? setEditingQuestion({ ...editingQuestion, correctOption: parseInt(e.target.value) })
                      : setNewQuestion({ ...newQuestion, correctOption: parseInt(e.target.value) })
                  }
                />
                {abc[num - 1]}
              </label>
            ))}

          </div>
          <h4>Área objetiva</h4>
          <div className={styles.radioGroup} style={{ display: 'flex', gap: '10px' }}>
            {pilarKeys.map((key, idx) => (
              <label key={key} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <input
                  type="checkbox"
                  // 2) checked vem do objeto editingPilar[key]
                  checked={editingPilar[key]}
                  // 3) ao mudar, basta fazer toggle daquele boolean
                  onChange={() =>
                    setEditingPilar(prev => ({
                      ...prev,
                      [key]: !prev[key]
                    }))
                  }
                />
                {pilares[idx]}
              </label>
            ))}
          </div>



          <button
            className='questionButton'
            onClick={editingQuestion ? editQuestion : addQuestion}
            title='Confirmar'
          >
            {editingQuestion ? 'Salvar Edição' : 'Confirmar envio de nova questão'}
          </button>
        </div>
        <br />
        <div className={styles.questionList}>
          <h2>Questões Cadastradas</h2>
          {questions.map((question, index) => (
            <div key={question.id} className={styles.questionItem}>
              <p>{index + 1}.<strong>Descrição:</strong> {question.desc}</p>
              {question.img && (
                <img
                  src={question.img}
                  alt="Pré-visualização da imagem"
                  style={{ maxWidth: '100px', marginBottom: '10px' }}
                />
              )}
              <p><strong>Alternativa Correta:</strong> {abc[question.correctOption - 1]}</p>
              <button onClick={() => setEditingQuestion(question)} title='Editar'>Editar</button>
              <button onClick={() => deleteQuestion(question.id)} title='Excluir'>Excluir</button>
            </div>
          ))}
        </div>
      </Board>
    </div>
  );
};
